import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import EcModal from '~/components/Shared/EcModal/EcModal';
import { useIntl } from 'react-intl';
import * as selectors from '~/redux/selectors';
import search from '~/redux/slices/search';
import { MODAL_DOCUMENT_GROUP } from '~/types/modal.types';

const AddSearchResultsToGroup = () => {
  const intl = useIntl();
  const modal = useSelector(selectors.selectSearchResultModal);
  const dispatch = useDispatch();
  const hideModal = () => dispatch(search.actions.setModal());
  const searchQuery = useSelector(selectors.selectQuery);
  const { modalType, context } = modal || {};

  if (modalType !== MODAL_DOCUMENT_GROUP) return null;

  const { selectedRowIds, isAllRowsSelected: isAllSelected } = context;

  return (
    <EcModal
      modalType={modalType}
      width="660px"
      title={intl.formatMessage({
        id: 'AddSearchResultsToGroup.addToGroupTitle',
        defaultMessage: 'Add to Group',
        description: 'Modal title for adding documents to group',
      })}
      documentIds={selectedRowIds}
      searchQuery={isAllSelected ? searchQuery : undefined}
      hideModal={hideModal}
    />
  );
};

export default AddSearchResultsToGroup;
